import { render, staticRenderFns } from "./NewsCom.vue?vue&type=template&id=1d000395&scoped=true"
import script from "./NewsCom.vue?vue&type=script&lang=js"
export * from "./NewsCom.vue?vue&type=script&lang=js"
import style0 from "./NewsCom.vue?vue&type=style&index=0&id=1d000395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d000395",
  null
  
)

export default component.exports